// @react
import React, { ReactElement } from 'react'
// @types
// @graphQL
// @components
import TopicsCards from 'modules/onBoarding/components/Topics/CardList'
import { useQuery } from '@apollo/client'
import {
  GetUserQuery,
  GetUserQueryVariables,
} from '../../../../lib/graphql/graphqlTypes'
import { GET_USER } from '../../../../graphql/queries/user.query'

const Topics = (): ReactElement => {
  const { data } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
  })

  return <TopicsCards userData={data} />
}

export default Topics
